// extracted by mini-css-extract-plugin
export default {"wrapper":"ScheduleInGoogleCalendar_wrapper__+YpUo","text":"ScheduleInGoogleCalendar_text__LCbc4"};